/**
 * "By the Numbers" — editorial credentials block.
 * Reformatted from the original 4-column big-number grid to a horizontal
 * line-item layout with stable typography. No overflowing numbers,
 * no industry-wide claims — only studio-specific positioning facts.
 */
const ROWS = [
    {
        kicker: "Founded",
        value: "2021",
        note: "Built natively for the AI-First Era — not retrofitted from a traditional PR shop.",
    },
    {
        kicker: "Operating Model",
        value: "Hybrid Studio",
        note: "AI velocity paired with human, journalist-grade auditing on every artefact.",
    },
    {
        kicker: "Focus",
        value: "High-Ticket B2B",
        note: "Engineered for complex sales cycles, qualified pipeline and reputation capital.",
    },
    {
        kicker: "Discipline",
        value: "AMEC-Aligned",
        note: "Outcomes measured against the integrated PR & comms framework — not vanity metrics.",
    },
];

export default function Stats() {
    return (
        <section
            id="stats"
            data-testid="stats-section"
            className="relative py-24 md:py-32 border-y border-[#26262a] bg-[#050505]"
        >
            <div className="max-w-[1400px] mx-auto px-6 md:px-10">
                <div className="grid md:grid-cols-12 gap-8 mb-14 reveal">
                    <div className="md:col-span-5">
                        <div className="text-[11px] uppercase tracking-[0.3em] text-[#e6192b] mb-5">
                            ⎯⎯ §07 · By the Numbers
                        </div>
                        <h2 className="font-serif-display text-4xl md:text-5xl lg:text-6xl leading-[0.98] tracking-tight">
                            A studio,{" "}
                            <span className="italic text-[#a0a0ab]">
                                on the record.
                            </span>
                        </h2>
                    </div>
                    <p className="md:col-span-6 md:col-start-7 self-end text-[#a0a0ab] leading-relaxed">
                        We don&apos;t lead with industry-wide forecasts or
                        invented multipliers. The facts that matter to a serious
                        buyer are below — verifiable, specific to Pixelgrok, and
                        the operating principles your team will work with from
                        day one.
                    </p>
                </div>

                <ul className="border-t border-[#26262a]">
                    {ROWS.map(({ kicker, value, note }, i) => (
                        <li
                            key={kicker}
                            data-testid={`stat-${i}`}
                            className="grid grid-cols-12 gap-x-6 gap-y-3 py-7 md:py-8 border-b border-[#26262a] items-baseline reveal group"
                            style={{ transitionDelay: `${i * 70}ms` }}
                        >
                            <div className="col-span-12 md:col-span-3 text-[11px] uppercase tracking-[0.22em] text-[#a0a0ab] group-hover:text-white transition-colors">
                                {kicker}
                            </div>
                            <div className="col-span-12 md:col-span-4 font-serif-display text-3xl md:text-4xl lg:text-5xl leading-none tracking-tight">
                                <span className="text-white">{value}</span>
                                <span className="text-[#e6192b] ml-1">.</span>
                            </div>
                            <div className="col-span-12 md:col-span-5 text-[14px] md:text-[15px] text-[#a0a0ab] leading-relaxed">
                                {note}
                            </div>
                        </li>
                    ))}
                </ul>
            </div>
        </section>
    );
}
